module.exports = __webpack_public_path__ + "img/agentmsg2.19b225af.jpg";